import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, isRef as _isRef, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "radio-group-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "input-label" }, [
  /*#__PURE__*/_createTextVNode("Czy jest Pan(i) pod opieką specjalisty lub poradni specjalistycznej? "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-error" }, "*")
], -1)
const _hoisted_3 = { class: "squared-radio-group" }
const _hoisted_4 = { class: "squared-radio-button" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "checkmark" }, "Tak", -1)
const _hoisted_6 = { class: "squared-radio-button" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "checkmark" }, "Nie", -1)
const _hoisted_8 = {
  key: 0,
  class: "error-message"
}

import { useField } from 'vee-validate';
import CarePersonField from './CarePersonField.vue';


export default {
  __name: 'HasCareField',
  setup(__props) {

const { value, errorMessage } = useField('hasCare');

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            name: "hasCare",
            value: "yes",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (_isRef(value) ? (value).value = $event : null)),
            type: "radio"
          }, null, 512), [
            [_vModelRadio, _unref(value)]
          ]),
          _hoisted_5
        ]),
        _createElementVNode("label", _hoisted_6, [
          _withDirectives(_createElementVNode("input", {
            name: "hasCare",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_isRef(value) ? (value).value = $event : null)),
            value: "no",
            type: "radio"
          }, null, 512), [
            [_vModelRadio, _unref(value)]
          ]),
          _hoisted_7
        ])
      ]),
      (_unref(errorMessage))
        ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_unref(errorMessage)), 1))
        : _createCommentVNode("", true)
    ]),
    (_unref(value) === 'yes')
      ? (_openBlock(), _createBlock(CarePersonField, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

}